export default __webpack_public_path__ + "static/11-8449d5b0af7845c493189d3efc322a45.jpg";